import { Outlet } from "react-router-dom";
import { DocumentList } from "../components/DocumentList";

export const DocumentsListPage = () => {
  return (
    <section className="documents-list-page main-page">
      <div className="main-page__content">
        <div className="main-page__header">
          <h1>Documents List</h1>
        </div>
        <div className="main-page__body">
          <DocumentList showCreateButton={true} />
        </div>
      </div>
      <Outlet />
    </section>
  );
};
